export default __webpack_public_path__ + "static/media/truck_rear_bw_cropped.9d72bcae.jpeg";